import PDF from '../index.js'
import moment from 'moment'

export default (company, invoice, lines, money) => {
    const pdf = Object.assign({}, PDF)
    let products = []
    for (let i = 0; i < lines.length; i++) {
        let item = lines[i]
        products.push([
            item.ItemName,
            item.Quantity,
            money(item.Price),
            money(item.SubTotal)
        ])
    }

    const home = (company.Home === null || company.Home === '') ? "" : ("Home: " + company.Home + ", ")
    const street = (company.Street === null || company.Street === '') ? "" : ("Street: " + company.Street + ", ")
    const village = (company.Village === null || company.Village === '') ? "" : (company.Village + " Village, ")
    const commune = (company.Commune === null || company.Commune === '') ? "" : (company.Commune + " Commune, ")
    const district = (company.District === null || company.District === '') ? "" : (company.District + " District, ")
    const capital = (company.Capital === null || company.Capital === '') ? "" : company.Capital
    const address = home + street + village + commune + district + capital

    let content = [
        {
            columns: [
                {
                    type: 'none',
                    width: "*",
                    ol: [{ image: 'logo', width: 80, height: 80, margin: [50, 0, 0, 0] },
                    ]
                }
            ],
        },
        { text: "" + company.LatinName, alignment: "center", bold: true, fontSize: 14, margin: [0, 10, 0, 0] },
        { text: address, alignment: "center" },
        { text: "Email: " + company.Email, alignment: "center" },
        { text: "Tel: " + company.Phone, alignment: "center" },
        {
            canvas: [
                {
                    type: 'line',
                    x1: 0, y1: 10,
                    x2: 206, y2: 10,
                    lineWidth: 1
                }
            ]
        },
        {
            margin: [0, 5, 0, 0],
            layout: "noBorders",
            table: {
                headerRows: 0,
                widths: [50, 5, "*"],
                body: [
                    [{ text: "Date", bold: true }, { text: ":" }, { text: moment().format('DD/MM/YYYY HH:mm:ss A') }],
                    [{ text: "Seller", bold: true }, { text: ":" }, { text: company.UserLogin }],
                    [{ text: "Customer", bold: true }, { text: ":" }, { text: invoice.CustomerName }]
                ],
            },
        },
        {
            canvas: [
                {
                    type: 'line',
                    x1: 0, y1: 5,
                    x2: 206, y2: 5,
                    lineWidth: 1
                }
            ]
        },
        {
            margin: [0, 15, 0, 0],
            layout: "headerLineOnly",
            table: {
                headerRows: 1,
                widths: ["*", 20, 40, 40],
                body: [
                    [
                        { text: "Description", bold: true },
                        { text: "QTY", bold: true },
                        { text: "Unit Price", bold: true },
                        { text: "Amount", bold: true },
                    ],
                    ...products
                ],
            },
        },
        {
            canvas: [
                {
                    type: 'line',
                    x1: 0, y1: 5,
                    x2: 206, y2: 5,
                    lineWidth: 1
                }
            ]
        },
        {
            margin: [0, 5, 0, 0],
            layout: "noBorders",
            table: {
                headerRows: 0,
                widths: ["*", 40],
                body: [
                    [{ text: "Sub-total", bold: true, alignment: 'right' }, { text: money(invoice.GrandTotal) }],
                    [{ text: "Discount", bold: true, alignment: 'right' }, { text: money(invoice.Discount) }],
                    [{ text: "Grand Total", bold: true, alignment: 'right' }, { text: money(invoice.TotalAmount) }],
                ],
            },
        },
    ]
    pdf.fontSize = 8
    pdf.load(content)
}
